import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/Contexts/AuthContext';
import './ManagementPage.css';
import 'src/Pages/Management/forms/FormField.css';

import CompaniesTab from './tabs/CompaniesTab';
import ProjectsTab from './tabs/ProjectsTab';
import InstallationsTab from './tabs/InstallationsTab';
import UsersTab from './tabs/UsersTab';

type TabKey = 'companies' | 'projects' | 'installations' | 'users';

const ManagementPage = () => {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState<TabKey>('companies');

  if (!currentUser?.is_admin) {
    return (
      <div className="management-page">
        <p>{t('management.accessDenied')}</p>
      </div>
    );
  }

  const tabs: { key: TabKey; label: string }[] = [
    { key: 'companies', label: t('management.companies') },
    { key: 'projects', label: t('management.projects') },
    { key: 'installations', label: t('management.installations') },
    { key: 'users', label: t('management.users') },
  ];

  return (
    <div className="management-page">
      <h1 className="management-page-title">{t('management.title')}</h1>
      <nav className="management-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`management-tab ${activeTab === tab.key ? 'management-tab--active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <div className="management-tab-content">
        {activeTab === 'companies' && <CompaniesTab />}
        {activeTab === 'projects' && <ProjectsTab />}
        {activeTab === 'installations' && <InstallationsTab />}
        {activeTab === 'users' && <UsersTab />}
      </div>
    </div>
  );
};

export default ManagementPage;
